import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'y42-context-menu-border-color',
  styleUrls: ['context-menu-border-color.component.scss'],
  templateUrl: './context-menu-border-color.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContextMenuBorderColorComponent {
  @Input()
  borderColor?: string;

  @Input()
  label = 'Border';

  @Output()
  borderColorChanged = new EventEmitter<string>();
}
